module.exports = __webpack_public_path__ + "static/media/password-off.de03ff08.svg";